import { lazy } from 'react';

// Lazy Load Components
const Home = lazy(() => import('../../pages/WebsitePages/layoutPages/Home'));
const Registration = lazy(() => import('../../pages/WebsitePages/auth/registration/registration'));
const Login = lazy(() => import('../../pages/WebsitePages/auth/login'));
const ApplicationForm = lazy(() => import('../../pages/WebsitePages/Components/applicationForm'));
const Dashboard = lazy(() => import('../../pages/WebsitePages/Components/dashboard'));
const AdminDashboard = lazy(() => import('../../pages/AdminPages/pages/dashboard'));
const ForgetPassword = lazy(() => import('../../pages/WebsitePages/auth/forget-Password'));
const ResetPassword = lazy(() => import('../../pages/WebsitePages/auth/reset-password'));
const KendraRegistration = lazy(() => import('../../pages/WebsitePages/Components/KendraRegistration'));
const OtpVerification = lazy(() => import('../../pages/WebsitePages/auth/otp-verification'));
const PageNotFound = lazy(() => import('../../pages/AdminPages/pages/pageNotFound'));
const AdminLogin = lazy(() => import('../../pages/AdminPages/auth/AdminLogin'));
const UserList = lazy(() => import('../../pages/AdminPages/pages/userList'));
const RecruitementForm = lazy(() => import('../../pages/WebsitePages/Components/RecruitementForm'));
const CancleApplication = lazy(() => import("../../pages/AdminPages/pages/CancleApplication"));
const RejectApplication = lazy(() => import("../../pages/AdminPages/pages/rejectApplication"));
const ApprovedApplication = lazy(() => import("../../pages/AdminPages/pages/approvedApplication"));
const AddUser = lazy(() => import("../../pages/AdminPages/pages/addUser"));
const ViewApplication = lazy(() => import("../../pages/AdminPages/pages/viewApplication"));
const PaymentPage = lazy(() => import("../../pages/WebsitePages/Components/PaymentPage"));
const MyApplication = lazy(() => import("../../pages/WebsitePages/Components/my-application"));
const MessagePage = lazy(() => import("../../pages/WebsitePages/Components/MessagePage"));
const UserAddSuccess = lazy(() => import("../../pages/AdminPages/pages/userAddSuccess"));
const Recruitment = lazy(() => import("../../pages/WebsitePages/Components/Recruitment"));
const RecruitmentList = lazy(() => import("../../pages/AdminPages/pages/recruitmentList"));
const AddRecruitment = lazy(() => import("../../pages/AdminPages/pages/addRecruitment"));
const JobAddSuccess = lazy(() => import("../../pages/AdminPages/pages/jobAddSuccess"));
const Governance = lazy(() => import("../../pages/WebsitePages/Components/governance/Governance"));
const ViewResume = lazy(() => import("../../pages/AdminPages/pages/viewResume"));
const ProductPortfolio = lazy(() => import("../../pages/WebsitePages/Components/ProductPortfolio"));
const RtiAct = lazy(() => import("../../pages/WebsitePages/Components/RtiAct"));
const ContactUs = lazy(() => import("../../pages/WebsitePages/Components/ContactUs"));
const Media = lazy(() => import("../../pages/WebsitePages/Components/Media"));
const DrugLicensePage = lazy(() => import("../../pages/WebsitePages/Components/DrugLicensePage"));
const AdminForgotPassword = lazy(() => import("../../pages/AdminPages/auth/forgot-password"));
const ApplySuccessfuly = lazy(() => import("../../pages/WebsitePages/Components/apply-successfuly"));
const PmbjpScheme = lazy(() => import("../../pages/WebsitePages/Components/AboutScheme/PmbjpScheme"));
const Faq = lazy(() => import("../../pages/WebsitePages/Components/AboutScheme/Faq"));
const LocateData = lazy(() => import("../../pages/WebsitePages/Components/AboutScheme/LocateData"));
const LocateDistributor = lazy(() => import("../../pages/WebsitePages/Components/AboutScheme/LocateDistributor"));
const PmHospital = lazy(() => import("../../pages/WebsitePages/Components/AboutScheme/PmHospital"));
const AnnualReport = lazy(() => import("../../pages/WebsitePages/Components/AboutScheme/AnnualReport"));
const FinanceReport = lazy(() => import("../../pages/WebsitePages/Components/AboutScheme/FinanceReport"));
const PharmacistDetails = lazy(() => import("../../pages/WebsitePages/Components/AboutScheme/PharmacistDetails"));
const UpdateBanner = lazy(() => import("../../pages/AdminPages/pages/UpdateBanner"));
const UploadPhoto = lazy(() => import("../../pages/AdminPages/pages/UploadPhoto"));
const Tenderlist = lazy(() => import("../../pages/AdminPages/pages/Tenderlist"));
const AddProductPortfolio = lazy(() => import("../../pages/AdminPages/pages/AddProductPortfolio"));
const UpdateKendra = lazy(() => import("../../pages/AdminPages/pages/UpdateKendra"));
const NewPassword = lazy(() => import("../../pages/AdminPages/auth/new-password"));
const ChangeProfile = lazy(() => import("../../pages/AdminPages/auth/change-profile"));
const ComplitePayment = lazy(() => import("../../pages/WebsitePages/Components/complitePayment"));
const PacsTraining = lazy(() => import("../../pages/WebsitePages/Components/Support/PacsTraining"));
const PosTraining = lazy(() => import("../../pages/WebsitePages/Components/Support/PosTraining"));
const WebinarTutprial = lazy(() => import("../../pages/WebsitePages/Components/Support/WebinarTutprial"));
const KendraComplains = lazy(() => import("../../pages/WebsitePages/Components/Support/KendraComplains"));
const SugamHelpLine = lazy(() => import("../../pages/WebsitePages/Components/Support/SugamHelpLine"));
const SoftwareHelpline = lazy(() => import("../../pages/WebsitePages/Components/Support/SoftwareHelpline"));
const DownloadLink = lazy(() => import("../../pages/WebsitePages/Components/Support/DownloadLink"));
const VendorPortal = lazy(() => import("../../pages/WebsitePages/Components/Support/VendorPortal"));
const PharmacistRegistration = lazy(() => import("../../pages/WebsitePages/Components/PharmacistRegistration"));
const NewTender = lazy(() => import("../../pages/AdminPages/pages/NewTender"));
const ResumePrint = lazy(() => import("../../pages/AdminPages/pages/ResumePrint"));
const RedirectpaymentPage = lazy(() => import("../../pages/WebsitePages/Components/redirectpaymentPage"));
const Executive = lazy(() => import("../../pages/WebsitePages/Components/governance/Executive"));
const Organization = lazy(() => import("../../pages/WebsitePages/Components/governance/Organization"));
const Managements = lazy(() => import("../../pages/WebsitePages/Components/governance/Managements"));
const PharmacistList = lazy(() => import("../../pages/AdminPages/pages/PharmacistList"));
const ProductList = lazy(() => import("../../pages/AdminPages/pages/ProductList"));
const KendraList = lazy(() => import("../../pages/AdminPages/pages/KendraList"));
const ContactList = lazy(() => import("../../pages/AdminPages/pages/ContactList"));
const AddContact = lazy(() => import("../../pages/AdminPages/pages/AddContact"));
const LocatorList = lazy(() => import("../../pages/AdminPages/pages/LocatorList"));
const AdminLocateDistributor = lazy(() => import("../../pages/AdminPages/pages/Locate-Distributor"));
const CopyRight = lazy(() => import("../../pages/WebsitePages/Components/NeedHelp/copyRight"));
const HyperLinkPolicy = lazy(() => import("../../pages/WebsitePages/Components/NeedHelp/hyperLinkPolicy"));
const PrivacyPolicy = lazy(() => import("../../pages/WebsitePages/Components/NeedHelp/privacyPolicy"));
const Disclamer = lazy(() => import("../../pages/WebsitePages/Components/NeedHelp/disclamer"));
const FeedBack = lazy(() => import("../../pages/WebsitePages/Components/NeedHelp/feedBack"));
const TermsAndCondition = lazy(() => import("../../pages/WebsitePages/Components/NeedHelp/terms-and-condition"));
const NearByPharma = lazy(() => import("../../pages/WebsitePages/Components/nearByPharma"));
const NearByKendraPage = lazy(() => import("../../pages/WebsitePages/Components/nearByKendraPage"));
const AddDebarred = lazy(() => import("../../pages/AdminPages/pages/AddDebarred"));
const Testimonials = lazy(() => import("../../pages/WebsitePages/Components/Testimonials"));
const SiteMap = lazy(() => import("../../pages/WebsitePages/Components/SiteMap"));
const Tender = lazy(() => import("../../pages/WebsitePages/Components/tender/Tender"));
const Debarred = lazy(() => import("../../pages/WebsitePages/Components/tender/Debarred"));
const Awarded = lazy(() => import("../../pages/WebsitePages/Components/tender/Awarded"));
const Blacklist = lazy(() => import("../../pages/WebsitePages/Components/tender/BlackList"));
const Revocation = lazy(() => import("../../pages/WebsitePages/Components/tender/Revocation"));
const AddBlackList = lazy(() => import("../../pages/AdminPages/pages/AddBlackList"));
const AddAwardedList = lazy(() => import("../../pages/AdminPages/pages/AddAwarded"));
const AddRevocation = lazy(() => import("../../pages/AdminPages/pages/AddRevocation"));
const ManagementList = lazy(() => import("../../pages/AdminPages/pages/ManagementList"));
const AddManagament = lazy(() => import("../../pages/AdminPages/pages/AddManagament"));
const NewsList = lazy(() => import("../../pages/AdminPages/pages/NewsList"));
const AddWhatsNew = lazy(() => import("../../pages/AdminPages/pages/AddWhat'sNew"));
const AddNews = lazy(() => import("../../pages/AdminPages/pages/AddNews"));
const NewsDetail = lazy(() => import("../../pages/WebsitePages/NewsDetail"));
const ReportList = lazy(() => import("../../pages/AdminPages/pages/ReportList"));
const AddReport = lazy(() => import("../../pages/AdminPages/pages/AddReports"));
const ImageList = lazy(() => import("../../pages/AdminPages/pages/ImageList"));
const Archive = lazy(() => import("../../pages/WebsitePages/Components/Archive/Archive"));
const Debbarred = lazy(() => import("../../pages/WebsitePages/Components/Archive/Debbarred"));
const Ebroucher = lazy(() => import("../../pages/WebsitePages/Components/Archive/Ebroucher"));
const Esamvad = lazy(() => import("../../pages/WebsitePages/Components/Archive/Esamvad"));
const Others = lazy(() => import("../../pages/WebsitePages/Components/Archive/Others"));
const Reports = lazy(() => import("../../pages/WebsitePages/Components/Archive/Reports"));
const VartaEditions = lazy(() => import("../../pages/WebsitePages/Components/Archive/VartaEditions"));
const BlacklistData = lazy(() => import("../../pages/WebsitePages/Components/Archive/BlacklistData"));
const RecruitmentData = lazy(() => import("../../pages/WebsitePages/Components/Archive/RecruitmentData"));
const TenderData = lazy(() => import("../../pages/WebsitePages/Components/Archive/TenderData"));
const FinancialData = lazy(() => import("../../pages/WebsitePages/Components/Archive/FinancialData"));
const AnnualReportsData = lazy(() => import("../../pages/WebsitePages/Components/Archive/AnnualReportsData"));
const Gallery = lazy(() => import("../../pages/WebsitePages/Components/Archive/Gallery"));
const AwardedData = lazy(() => import("../../pages/WebsitePages/Components/Archive/AwardedData"));
const RevocationData = lazy(() => import("../../pages/WebsitePages/Components/Archive/RevocationData"));
const MediaList = lazy(() => import("../../pages/AdminPages/pages/MediaList"));
const ScreenRecordData = lazy(() => import("../../pages/WebsitePages/Components/ScreenRecordData"));
const GalleryMain = lazy(() => import("../../pages/WebsitePages/Components/galleryMain"));
const AddEvent = lazy(() => import("../../pages/AdminPages/pages/AddEvents"));
const ApplicationDetailsPrint = lazy(() => import("../../pages/WebsitePages/Components/applicationDetailsPrint"));
const GalleryDetails = lazy(() => import("../../pages/WebsitePages/Components/galleryDetails"));
const GalleryArchiveDetails = lazy(() => import("../../pages/WebsitePages/Components/galleryArchiveDetails"));


export {
    Home,
    Registration,
    Login,
    ApplicationForm,
    Dashboard,
    AdminDashboard,
    ForgetPassword,
    ResetPassword,
    KendraRegistration,
    OtpVerification,
    PageNotFound,
    AdminLogin,
    UserList,
    RecruitementForm,
    Tender,
    Debarred,
    Awarded,
    Blacklist,
    Revocation,
    AddBlackList,
    AddAwardedList,
    AddRevocation,
    ManagementList,
    AddManagament,
    NewsList,
    AddWhatsNew,
    AddNews,
    NewsDetail,
    ReportList,
    AddReport,
    ImageList,
    Archive,
    Debbarred,
    Ebroucher,
    Esamvad,
    Others,
    Reports,
    VartaEditions,
    BlacklistData,
    RecruitmentData,
    TenderData,
    FinancialData,
    AnnualReportsData,
    Gallery,
    AwardedData,
    RevocationData,
    MediaList,
    ScreenRecordData,
    GalleryMain,
    AddEvent,
    ApplicationDetailsPrint,
    GalleryDetails,
    GalleryArchiveDetails,
    CancleApplication,
    RejectApplication,
    ApprovedApplication,
    AddUser,
    ViewApplication,
    PaymentPage,
    MyApplication,
    MessagePage,
    UserAddSuccess,
    RecruitmentList,
    AddRecruitment,
    JobAddSuccess,
    ViewResume,
    Governance,
    SiteMap,
    AddDebarred,
    Testimonials,
    TermsAndCondition,
    NearByPharma,
    NearByKendraPage,
    DownloadLink,
    VendorPortal,
    PharmacistRegistration,
    NewTender,
    ResumePrint,
    RedirectpaymentPage,
    Executive,
    Organization,
    Managements,
    PharmacistList,
    ProductList,
    KendraList,
    ContactList,
    AddContact,
    LocatorList,
    AdminLocateDistributor,
    CopyRight,
    HyperLinkPolicy,
    PrivacyPolicy,
    Disclamer,
    FeedBack,
    LocateData,
    Faq,
    PmbjpScheme,
    ApplySuccessfuly,
    AdminForgotPassword,
    DrugLicensePage,
    Media,
    ContactUs,
    RtiAct,
    ProductPortfolio,
    NewPassword,
    ChangeProfile,
    UpdateKendra,
    AddProductPortfolio,
    Tenderlist,
    UploadPhoto,
    UpdateBanner,
    PharmacistDetails,
    FinanceReport,
    AnnualReport,
    PmHospital,
    LocateDistributor,
    SoftwareHelpline,
    SugamHelpLine,
    KendraComplains,
    WebinarTutprial,
    PosTraining,
    PacsTraining,
    ComplitePayment,
    Recruitment
};